export default {
  smart: {
    valor: "Valor",
    mantenimiento: "En manteniment",
    tiemporeal: {
      tiemporeal: "Temps real",
      qualitataire: "Qualitat de l'aire",
      qualitataire_gasos: "Qualitat de gasos",
      qualitataire_particules: "Qualitat de partícules",
      calidad3_1: "Bé",
      calidad3_2: "Moderat",
      calidad3_3: "Roí",
      nivellso: "Nivell de so",
      gases: "Gasos",
      qualitat_texto: "Per a facilitar la compressió del nivell de qualitat de l'aire d'Alcoi, s'ha establit una classificació en tres nivells a partir de la normativa del DR 102/2011 i la Llei 39/2017.",
      qualitat: "Qualitat",
      nivel: "Nivells",
      bueno: "Bé",
      moderado: "Moderat",
      malo: "Roí",
      no2: "Diòxid de nitrògen",
      no2_des: "El diòxid de nitrogen o òxid de nitrogen (IV) (NO2), és un compost químic format pels elements nitrogen i oxigen, un dels principals contaminants entre els diversos òxids de nitrogen.",
      o3: "Ozó",
      o3_des: "L'ozó és una substància la molècula de la qual està composta per tres àtoms d'oxigen, formada al dissociar-se els dos àtoms que componen el gas d'oxigen. Cada àtom d'oxigen alliberat s'unix a una altra molècula d'oxigen gasós (O2) , formant molècules d'ozó (O3).",
      so2: "Diòxid de sofre",
      so2_des: "El diòxid de sofre, o òxid de sofre, és un òxid la fórmula molecular del qual és SO₂. És un gas incolor amb una característica olor asfixiant.",
      co: "Monòxid de carboni",
      co_des: "El monòxid de carboni, també denominat òxid de carboni (II), gas carbònic i anhídrid carbònic.",
      co2: "Diòxid de carboni",
      pm1_des: "Partícules de grandària menor a 1 μm. Exemples: pols ultrafina, partícules de combustió, bacteris i virus.",
      pm25_des: "Partícules de grandària menor a 2,5 μm. Són partícules molt xicotetes suspeses en l'aire que tenen un diàmetre de menys de 2,5 micres. Les partícules poden incloure substàncies químiques orgàniques, pols, sutge i metalls, també poden provindre de totes les classes de combustió, com la dels automòbils, camions, fàbriques, cremes de fusta, cremes agrícoles i altres activitats.",
      pm10_des: "Partícules de grandària menor a 10 μm. Exemples: pols més gruixuda i partícules orgàniques, també podria ser cendra, sutge, partícules metàl·liques, ciment o pol·len, disperses en l'atmosfera, i el diàmetre aerodinàmic de la qual és menor que 10 µm.",
      actualizado: "Actualitzat a",
      particulas: "Partícules",
      nivelsonido: "Nivell de so",
      actual: "Actual",
      maximo: "Màxim",
      meteo: "Dades meteorològiques",
      temperatura: "Temperatura",
      humedad: "Humitat",
      presion: "Pressió",
      luminosidad: "Lluminositat",
      radiacion_solar: "Radiació solar",
      viento_dir: "Direcció del vent",
      viento_vel: "Velocitat del vent",
      lluvia: "Quantitat de pluja",
      aparcamiento: "Aparcament",
      plazas_totales: "Places totals",
      plazas_libres: "Places lliures",
      energia: "Energia",
      energia_producida: "Energia produïda",
      energia_consumida: "Energia consumida",
      energia_externa: "Energia externa",
    },
    indicadores: {
      indicadores: "Indicadors",
      ciudad: "Ciutat",
      economia: "Economia",
      agua: "Aigua",
      entorno: "Entorn",
      salud: "Salut",
      residuos: "Residus",
      tecnologia: "Tecnologia",
      turismo: "Turisme",
      "ISO4.1_tit": "Població",
      "ISO4.1_des": "Població total de la ciutat",
      "ISO4.3_tit": "Densitat de població",
      "ISO4.3_des": "Densitat de població",
      "ISO4.18_tit": "Canvi anual de població",
      "ISO4.18_des": "Canvi anual de població",
      "ISO4.22_tit": "Població infantil",
      "ISO4.22_des": "Percentatge de població format per xiquets entre 0-14",
      "ISO4.16_tit": "Població jove",
      "ISO4.16_des": "Percentatge de població format per persones joves",
      "ISO4.23_tit": "Població adulta",
      "ISO4.23_des": "Percentatge de població format per adults entre 25-64",
      "ISO4.17_tit": "Població major",
      "ISO4.17_des": "Percentatge de població format per persones majors de 65",
      "ISO4.24_tit": "Ràtio home/dona",
      "ISO4.24_des": "Nombre d'homes per cada 100 dones",
      "ISO4.26_tit": "Població nascuda a l'estranger",
      "ISO4.26_des": "Població nascuda a l'estranger",
      "ISO5.1_tit": "Taxa de desocupació",
      "ISO5.1_des": "Nombre de residents en edat de treballar que no tenien una ocupació remunerada ni eren autònoms, però sí que podien treballar i buscaven treball, dividit per la població activa total",
      "ISO5.5_tit": "Desocupació juvenil",
      "ISO5.5_des": "Nombre total de joves sense ocupació dividida per la població activa jove",
      "ISO5.6_tit": "Nombre d'empreses",
      "ISO5.6_des": "Nombre total d'empreses en una ciutat dividit per una cent mil·lèsima part de la població total de la ciutat",
      "ISO8.2_tit": "Partícules en suspensió PM10",
      "ISO8.2_des": "Massa total de partícules recollides en el rang de grandària de PM10 dividida pel volum d'aire mostrejat",
      "ISO8.2_pie": "Font: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.4_tit": "Concentració NO2",
      "ISO8.4_des": "Suma de les concentracions diàries de tot l'any dividida per 365 dies",
      "ISO8.4_pie": "Font: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.5_tit": "Concentració SO2",
      "ISO8.5_des": "Suma de les concentracions diàries de tot l'any dividida per 365 dies",
      "ISO8.5_pie": "Font: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.6_tit": "Concentració O3",
      "ISO8.6_des": "Suma de les concentracions diàries de tot l'any dividida per 365 dies",
      "ISO8.6_pie": "Font: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO12.3_tit": "Metges",
      "ISO12.3_des": "Nombre de metges de medicina general o especialistes dividit per una cent mil·lèsima part de la població total de la ciutat",
      "ISO12.5_tit": "Infermeres/Obstetrícia",
      "ISO12.5_des": "Nombre total d'infermeres i personal d'obstetrícia dividit per una cent mil·lèsima part de la població total de la ciutat",
      "ISO12.6_tit": "Salut mental",
      "ISO12.6_des": "Nombre de professionals de la salut mental dividit per una cent mil·lèsima part de la població total de la ciutat",
      "ISO21.1_tit": "Subministrament d'aigua potable",
      "ISO21.1_des": "Nombre total de persones amb servei de subministrament d'aigua potable dividit per la població total de la ciutat",
      "ISO21.2_tit": "Accés aigua millorada",
      "ISO21.2_des": "Població total amb accés a una font d'aigua millorada dividida per la població total de la ciutat",
      "ISO21.3_tit": "Accés instal·lacions sanitàries",
      "ISO21.3_des": "Nombre total de persones que utilitzen instal·lacions de sanejament millorades dividit per la població total de la ciutat",
      "ISO21.4_tit": "Consum domèstic",
      "ISO21.4_des": "Consum total d'aigua de la ciutat en litres per dia per a ús domèstic dividit per la població total de la ciutat",
      "ISO21.5_tit": "Consum total",
      "ISO21.5_des": "Quantitat total de consum d'aigua de la ciutat en litres per dia dividida per la població total de la ciutat",
      "ISO21.6_tit": "Interrupcions del servei",
      "ISO21.6_des": "Quantitat total d'hores d'interrupció, multiplicada pel nombre de llars afectades i dividit pel nombre de llars",
      "ISO21.7_tit": "Pèrdua d'aigua",
      "ISO21.7_des": "Volum d'aigua proveïda menys el volum d'aigua utilitzada dividit pel volum total d'aigua proveïda",
      IP_RE_RV1_tit: "Recollida Viària - Resta",
      IP_RE_RV1_des: "Recollida Viària - Resta",
      IP_RE_RV2_tit: "Recollida Viària - Cartó",
      IP_RE_RV2_des: "Recollida Viària - Cartó",
      IP_RE_RV3_tit: "Recollida Viària - Cristall",
      IP_RE_RV3_des: "Recollida Viària - Cristall",
      IP_RE_RV4_tit: "Recollida Viària - Envasos",
      IP_RE_RV4_des: "Recollida Viària - Envasos",
      IP_RE_RV5_tit: "Recollida Viària - Voluminosos",
      IP_RE_RV5_des: "Recollida Viària - Voluminosos",
      IP_RE_RV6_tit: "Recollida Viària - Orgànica",
      IP_RE_RV6_des: "Recollida Viària - Orgànica",
      IP_RE_RV7_tit: "Recollida Viària - Neteja viària",
      IP_RE_RV7_des: "Recollida Viària - Neteja viària",
      IP_RE_RV8_tit: "Recollida Viària - Roba tèxtil",
      IP_RE_RV8_des: "Recollida Viària - Roba tèxtil",
      IP_RE_RV9_tit: "Recollida Viària - Oli usat",
      IP_RE_RV9_des: "Recollida Viària - Oli usat",
      IP_RE_EC1_tit: "Ecoparc - Poda (més urbanitzacions)",
      IP_RE_EC1_des: "Ecoparc - Poda (més urbanitzacions)",
      IP_RE_EC2_tit: "Ecoparc - Fusta",
      IP_RE_EC2_des: "Ecoparc - Fusta",
      IP_RE_EC3_tit: "Ecoparc - Aparells elèctrics i electrònics",
      IP_RE_EC3_des: "Ecoparc - Aparells elèctrics i electrònics",
      IP_RE_EC4_tit: "Ecoparc - Tòxics",
      IP_RE_EC4_des: "Ecoparc - Tòxics",
      IP_RE_EC5_tit: "Ecoparc - Enderrocs",
      IP_RE_EC5_des: "Ecoparc - Enderrocs",
      IP_RE_EC6_tit: "Ecoparc - Plàstics",
      IP_RE_EC6_des: "Ecoparc - Plàstics",
      IP_RE_EC7_tit: "Ecoparc - Pneumàtics",
      IP_RE_EC7_des: "Ecoparc - Pneumàtics",
      IP_RE_EC8_tit: "Ecoparc - Matalassos",
      IP_RE_EC8_des: "Ecoparc - Matalassos",
      IP_RE_EC10_tit: "Ecoparc - Ferralla",
      IP_RE_EC10_des: "Ecoparc - Ferralla",
      IP_TE_SE1_tit: "Seu Electrònica - Visites",
      IP_TE_SE1_des: "Nombre de pàgines visitades en la seu electrònica",
      IP_TE_WF1_tit: "Punts Wi-Fi",
      IP_TE_WF1_des: "Nombre de punts d'accés Wi-Fi",
      IP_TE_FO1_tit: "Fibra òptica",
      IP_TE_FO1_des: "Nombre de metres",
      IP_TU_VA1_tit: "Oficina de turisme - Visites Persones",
      IP_TU_VA1_des: "Visites ateses en l'oficina de turisme",
      IP_TU_PO1_tit: "Percentatge d'ocupació",
      IP_TU_PO1_des: "Percentatge d'ocupació allotjaments del destí",
      IP_TU_GT1_tit: "Despesa total",
      IP_TU_GT1_des: "Inversió Departament de Turisme",
      IP_TU_NU1_tit: "Usuaris web Alcoi Turisme",
      IP_TU_NU1_des: "Nombre d'usuaris individuals de la web Alcoi Turisme",
      IP_TU_NU2_tit: "Usuaris panell Multitouch 24h",
      IP_TU_NU2_des: "Nombre d'usuaris individuals del panell Multitouch 24h",
      IP_TU_NV1_tit: "Visites web Alcoi Turisme",
      IP_TU_NV1_des: "Nombre total de visites de la web Alcoi Turisme",
      IP_TU_NV2_tit: "Visites panell Multitouch 24h",
      IP_TU_NV2_des: "Nombre total de visites del panell Multitouch 24h",
      IP_TU_TA1_tit: "Tourist Info Alcoi - Total persones ateses en tots el mitjans",
      IP_TU_TA1_des: "Nombre total de persones ateses per qualsevol mitjà a l'oficina de turisme",
      metros: "Metres",
      visitas: "Visites",
      habitantes: "Habitants",
      toneladas: "Tones",
      unidades: "Unitats",
      euros: "Euros",
      usuarios: "Usuaris",
      personas: "Persones",
    },
  },
};
